import { TokenInfoModel } from "./token-info.model";
import { AccountingObjectMappingModel } from "./accounting-object-mapping.model";
import { CustomFieldBaseModel } from "../document/custom-field-base-model";

export class AccountingConfigurationsModel {
    system: AccountingSystemEnum | undefined;

    environment: AccountingEnvironmentEnum | undefined = AccountingEnvironmentEnum.Development;

    companyId: string = '';

    clientId: string = '';

    clientSecret: string = '';

    redirectUri: string = '';

    tokenEndpoint: string | undefined;

    tokenInfo: TokenInfoModel = new TokenInfoModel();

    state: string = '';

    scope: string = '';

    apiBaseUrl: string = '';

    discoveryDocumentUrl: string = '';

    objectMappings: AccountingObjectMappingModel[] = []; 

    customFields: CustomFieldBaseModel[] = [];

}

export enum AccountingSystemEnum {
    QuickBooks = 0,
}

export enum AccountingEnvironmentEnum {
    Development = 0,
    Staging = 1,
    Production = 2,
}